import { VpcFlavour } from "~/operations";

export const getVpcTypeFromFlavour = (
  vpcFlavour: VpcFlavour | null | undefined,
) => {
  if (!vpcFlavour) return "default";
  if (vpcFlavour === VpcFlavour.CustomVpc) return "custom";
  if (vpcFlavour === VpcFlavour.MondooIgw) return "mondoo";
  if (vpcFlavour === VpcFlavour.DefaultVpc) return "default";
  return "default";
};

export const getVpcFlavourFromType = (
  vpcType: "default" | "mondoo" | "custom" | null | undefined,
) => {
  if (!vpcType) return VpcFlavour.DefaultVpc;
  if (vpcType === "custom") return VpcFlavour.CustomVpc;
  if (vpcType === "mondoo") return VpcFlavour.MondooIgw;
  if (vpcType === "default") return VpcFlavour.DefaultVpc;
  return VpcFlavour.DefaultVpc;
};
